export const STEP_SPEED = 20;
